import React from 'react';
import { Form, Input, Button,Spin,Select,Result,DatePicker,Image,Switch,Card, message } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
  Col,
  Row,
} from 'reactstrap';

var CryptoJS = require("crypto-js");
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
var instance_id = "";

const { Option } = Select;

const { TextArea } = Input;
const t_time="HH:mm:ss"

class DeliveryReceivingForm extends React.Component {

  state = {
    
    datarequested:true,
    active:false,
    date:'',
    datasubmittedsuccessfully:false,
    receiving_note:'',
    companyprofile:{},

  }

  componentDidMount(){
    this.component_load()
  }


  //component load
  component_load=()=>{
    this.data_loaded()
  
  }

  data_loaded=()=>{
    this.setState({datarequested:true})

    axios
      .get(`${serverconfig.backendserverurl}/api/app_profile/${1}`)
      .then((res) => {
        this.setState({
          companyprofile: res.data,
        });
      });


  //get oder object
  let delivery_obj=this.props.delivery_obj

  this.setState({date:delivery_obj.orig_date})

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("username")){
    username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
  }else{
    username=''
  }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }


  this.setState({datarequested:false})
  this.setState({datasubmittedsuccessfully:false})

  }


     getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().split(' ')[0];
  };


  //submit button pressed
  handleFormSubmit=(event) =>{
    var delivery_number=this.props.delivery_obj.delivery_number

    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('time_of_receiving',this.getCurrentTime());
    form_data.append('delivery_number',delivery_number);
    form_data.append('receivers_note',this.state.receiving_note);
    form_data.append('username',username);

    axios.post(serverconfig.backendserverurl+'/customqueries/confirm_receiving_items', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {

     message.success(res.data.message, 3);
     this.setState({datarequested:false})
     //this.setState({datasubmittedsuccessfully:true})
     this.data_loaded()

     //update parent
     this.props.onRefresh()
     
    })
  .catch(error => console.log(error))


  }

  //get the delivery zone

  
  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )
    }else{

      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
              <Card>
              <Result
              status="success"
              title="Action successful"
              extra={[
                <Button  type='primary' 
                onClick={()=>{
                  this.component_load()
                }}>Finish</Button>,
              ]}
              />

              </Card>
          </div>
        )    

      }else{

      return (
        <div>
          <h3>DELIVERY RECEIVING FORM</h3>
          <Row>

            <Col xs="12" sm="6" lg="6" style={{padding: '5px'}}>
            <Card>
            <Form onFinish={(event) => this.handleFormSubmit(event)} >

              <FormItem label="Receiver's note">
                  <TextArea
                    placeholder="Note"
                    autoSize={{ minRows: 2, maxRows: 6 }}
                    value={this.state.receiving_note} 
                    onChange={(val)=>{this.setState({receiving_note:val.target.value})}} 
                  />

              </FormItem> 
        
            <FormItem>
              <Button  type="primary" htmlType="submit">Confirm Received</Button>
            </FormItem>
            </Form>

        </Card>
        </Col>
        </Row>

        </div>
      );
    }
    }

  }

}


export default DeliveryReceivingForm;



